"use client";

import type * as React from "react";
import { useRef } from "react";
import { Provider } from "react-redux";

import { MasterDataInitializer } from "@/components/providers/MasterDataInitializer";
import { makeStore, type AppStore } from "@/lib/redux/store";

type StoreProviderProps = {
  children: React.ReactNode;
};

export const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  const storeRef = useRef<AppStore | null>(null);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  return (
    <Provider store={storeRef.current}>
      <MasterDataInitializer>{children}</MasterDataInitializer>
    </Provider>
  );
};
